module.exports = __webpack_public_path__ + "img/logo.b039c741.png";